export const FEATURES = {
  OPS_MASKED_PHONE_NUMBERS: 'ops_masked_phone_numbers',
  REL_BNPL_TOGGLE: 'rel_bnpl_toggle',
  REL_CONTRACTS_V2: 'rel_contracts_v2',
  REL_MOVE_LITTER_TO_PAST_MODAL: 'rel_move_litter_to_past_modal',
  REL_BREEDER_PAYMENT_ENFORCEMENT: 'rel_breeder_payment_enforcement',
  REL_SHARED_PICKUP_PLAN: 'rel_shared_pickup_plan',
  REL_INSURANCE_POST_PAYMENT_PROMPTS: 'rel_insurance_post_payment_prompts',
  REL_INTRO_CALLS: 'rel_intro_calls',
  REL_LITTER_CHECK_INS: 'rel_litter_check_ins',
  REL_SIMILAR_BREEDS_FILTER: 'rel_similar_breeds_filter',
  REL_SEARCH_RESULTS_SORT: 'rel_search_results_sort',
  REL_LITTER_PAGE: 'rel_litter_page',
  REL_FAVORITE_LITTERS: 'rel_favorite_litters'
};
